export default "__VITE_ASSET__d4f8253b__"